import { api } from './api';

export interface PatronEZNotification {
  id: string;
  userId: string;
  workspaceId: string | null;
  kind: string;
  title: string;
  body: string;
  link: string | null;
  readAt: string | null;
  createdAt: string;
}

export const notificationsApi = {
  async list(unreadOnly = false): Promise<PatronEZNotification[]> {
    const r = await api.get<PatronEZNotification[]>('/api/notifications', { params: { unreadOnly: unreadOnly ? 'true' : undefined } });
    return r.data;
  },
  async markRead(ids: string[]): Promise<{ markedRead: number }> {
    const r = await api.post<{ markedRead: number }>('/api/notifications/mark-read', { ids });
    return r.data;
  },
  async dismiss(ids: string[]): Promise<{ dismissed: number }> {
    const r = await api.post<{ dismissed: number }>('/api/notifications/dismiss', { ids });
    return r.data;
  },
};
